import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { autoChecklistService } from "services";
import { uiActions } from "store";
import { ErrorResponse, OwnerType } from "types";

type ExperianFraudClearMutationProps = {
	applicationId: string;
	ownerType: OwnerType;
	notes: string;
	onSuccessHandler?: Function;
};

const useExperianClearFraudMutation = () => {
	const dispatch = useDispatch();

	return useMutation(
		({
			applicationId,
			ownerType,
			notes,
		}: ExperianFraudClearMutationProps) => {
			return autoChecklistService.experianClearFraud({
				applicationId,
				ownerType,
				notes,
			});
		},
		{
			onSuccess(data, { onSuccessHandler }) {
				dispatch(
					uiActions.showSuccessNotification({
						title: "Request to clear Fraud alert has been sent successfully",
					}),
				);
				onSuccessHandler?.();
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useExperianClearFraudMutation;
